import React from 'react';
import {
  StyleProp,
  StyleSheet,
  View,
  ViewStyle,
} from 'react-native';
import Svg, {Circle, Path} from 'react-native-svg';
import CCText from '@/Atoms/CCText';

type ErrorBannerProps = {
  message: string;
  testID?: string;
  style?: StyleProp<ViewStyle>;
};

function ErrorIcon() {
  return (
    <View testID="error-banner-icon" style={styles.iconWrap}>
      <Svg width={22} height={22} viewBox="0 0 24 24">
        <Circle
          cx="12"
          cy="12"
          r="9"
          fill="none"
          stroke="#B42318"
          strokeWidth={2}
        />
        <Path
          d="M12 7.5v5.5"
          fill="none"
          stroke="#B42318"
          strokeWidth={2}
          strokeLinecap="round"
        />
        <Circle cx="12" cy="16.5" r="1.15" fill="#B42318" />
      </Svg>
    </View>
  );
}

export default function ErrorBanner({
  message,
  testID,
  style,
}: ErrorBannerProps) {
  return (
    <View
      testID={testID}
      accessibilityRole="alert"
      accessibilityLiveRegion="polite"
      style={[styles.container, style]}>
      <ErrorIcon />
      <View style={styles.copy}>
        <CCText style={styles.message}>{message}</CCText>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 10,
    paddingVertical: 11,
    paddingHorizontal: 12,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: '#F3C9CE',
    backgroundColor: '#FDECEE',
  },
  iconWrap: {
    width: 28,
    height: 28,
    borderRadius: 14,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#FFDADD',
    flexShrink: 0,
  },
  copy: {
    flex: 1,
    minHeight: 28,
    justifyContent: 'center',
  },
  message: {
    color: '#B42318',
    fontSize: 13,
    fontWeight: '600',
    lineHeight: 19,
  },
});
